import { DicStayAreaFeaturePage } from "..";

/** 住宿点字典维护页面。 */
export function DicStayAreaPage() {
  return <DicStayAreaFeaturePage />;
}
